import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "popover"]

  connect() {
    this.syncPopover()
  }

  enableNext() {
    this.buttonTarget.disabled = false

    this.syncPopover()
  }

  syncPopover() {
    if (!this.buttonTarget.disabled && this.hasPopoverTarget) {
      this.popoverTarget.classList.add("hidden")
      this.popoverTarget.classList.remove("group-hover:block")
    }
  }
}
